import { FilterMatchMode } from '../enums/filter-match-mode.enum';

export interface TableFilter {
  [field: string]: {
    value: any,
    matchMode: FilterMatchMode,
  };
}
